export default {
	global : {
		name:"Nombre",
		bookings : 'Reservaciones',
		operation : 'Operación',
		operationAssignment : 'Asignación',
		import: 'Importar',
		importReservations: 'Importar Reservaciones',
		importReservation: 'Importar Reservación',
		downloadFormat: 'Descargar Formato',
		downloadFormatClean:"Formato vacio",
		downloadFormatExample:"Formato con ejemplo",
		validateInformation: 'Validar información',
		typesServices: 'Tipos de servicios',
		file: 'Archivo',
		dateFormat: 'Formato de fecha',
		timeFormat: 'Formato de hora',
		operationTracking : 'Operación en vivo',
		tracking: 'Seguimiento',
		transportUnits : 'Unidades',
		users : 'Usuarios',
		drivers : 'Conductores',
		profile : 'Perfil',
		logout : 'Salir',
		all : 'Todos',
		selectAll : 'TODOS',
		clean : 'Limpiar',
		search : 'Buscar',
		firstName : 'Nombres',
		lastName : 'Apellidos',
		save : 'Guardar',
		yes: 'Si',
		filters: 'Filtros',
		registerDeleted: 'Borrado exitosamente',
		serverError: 'El servidor no responde',
		filterByService: 'Filtrar por servicio',
		filteringByService: 'Se está filtrando por servicio',
		ajaxTable:{
			noRecordsFound:'No se encontraron resultados',
			selectAll:'Seleccionar todos',
			showingNRecords:'Mostrando {from} a {to} registros de {total}',
			massiveOperationsOn: 'Habilitar operaciones masivas',
			massiveOperationsOff: 'Deshabilitar operaciones masivas',
			assignConfirmation: 'Asignar confirmación',
			orderBy:"Ordenar por"
		},
		status: 'Estado',
		actions: 'Acciones',
		copy: 'Copiar',
		minutes: 'minutos',
		after: 'después',
		before: 'antes',
		ofFlight: 'del vuelo',
		delete: 'Eliminar',
		add: 'Agregar',
		phone : 'Teléfono',
		email : 'Correo',
		cancel : 'Cancelar',
		update: 'Actualizar',
		description: 'Descripción',
		change: 'Cambiar',
		upload: 'Subir',
		info: 'Información',
		image: 'Imagen',
		pos: 'PV',
		selectOption:'Seleccione una opción',
		errorsFound: 'Se encontraron los siguientes errores al procesar archivo:',
		GenerateReservations: 'Generar reservas',
		errorsFoundAlert: 'Se encontraron errores en el archivo, por favor verificar',
		successfullyRegistered: 'Reservas registradas con éxito',
		supplier: 'Proveedor',
		pointOfSale: 'Punto de venta',
		dashboard:'Panel',
		reports:"Reportes",
		seeLocation:"Ver ubicación",
		correctlyAdded: "Se agregó correctamente",
		changes: 'Cambios',
		idChange: 'ID del cambio',
		date: 'Fecha',
		user: 'Usuario',
		changeType: 'Tipo de cambio',
		field: 'Campo',
		new: 'Nuevo',
		edit: 'Editado',
		confirmMovePlaceToMap:"¿Está seguro que desea mapear manualmente el lugar:",
		placesNotDiscovered:"No se encontró coincidencia o hubieron varios resultados para los siguientes lugares",
		moveToPendingToMap:"Mover a pendientes por seleccionar",
		createBookings:"Generar reservaciones",
		modules:"Configuraciones",
		toEdit:"Editar",
		doneSuccessfully: "Realizado con éxito",
		shared:"Compartido",
		private:"Privado",
		registeredSuccess:"Se registró correctamente",
		manage:"Administrar",
		serviceTypes:"Tipos de servicio",
		saveYourChanges:"Guarda tus cambios",
		allFeaturesAlert: "Comuníquese para descubrir cómo acceder a todas las funciones.",
		restore:"Reeestablecer",
		prices:"Precios",
		salesChannels:"Canales de venta",
		genericError:"Algo salió mal realizando la operación"
	},
	warnings : {
		okToContinue : '¿Desea continuar con esta acción?',
		continue : 'Continuar',
		cancel : 'Cancelar',
		processing : 'Procesando',
	},
	bookings : {
		passengers: 'Pasajeros',
		notAccepted: 'No aceptada',
		clientName:'Nombre cliente',
		airports:'Aeropuertos',
		general:'General',
		destinations:'Destinos',
		salesReference:'ID canal de venta',
		supplierConfirmed: 'Servicio confirmado',
		referenceId:'Confirmación Proveedor',
		serviceType:'Tipo de servicio',
		serviceStatus:'Estado de servicio',
		pickupConfirmed:'Pickup confirmado',
		serviceDateFrom:'Servicios desde',
		serviceDateTo:'Servicios hasta',
		flightNotValidate:'Vuelo no validado',
		transportUnit:'Unidad',
		driver:'Conductor',
		trackingStatus:'Estado de proceso',
		trackingService: 'Seguimiento del servicio',
		serviceStatusOpts:{
			active:		'Activo',
			pending:	'Pendiente',
			noShow:		'No Show',
			noProvided:	'No atendido',
			canceled:	'Cancelado',
			done:		'Realizado',
			partialCancellation: 'Pre Cancelado',
		},
		trackingStatusOpts:{
			pending:'Listo para iniciar',
			onWayToPickup:'Rumbo al origen',
			atPickup:'En Origen',
			onWayToDropoff:'Rumbo al destino',
			finished:'Finalizado',
			noShow:'No show',
		},
		reservationStatusOpts:{
			active:'Activado',
			canceled:'Cancelado',
		},
		confirmed:'Confirmado',
		noConfirmed:'No confirmado',
		cancelDateFrom:'Fecha cancelación desde',
		cancelDateTo:'Fecha cancelación hasta',
		tripType:'Tipo de viaje',
		client:'Cliente',
		pickupDate:'Fecha pickup',
		trip:'Viaje',
		actions:'Acciones',
		export:'Exportar',
		booking:'Reservacion',
		clientInfo:'Datos de cliente',
		adults:'Adultos',
		kids:'Niños',
		infants:'Infantes',
		service:'Servicio',
		status:'Estado',
		origin:'Origen',
		destination:'Destino',
		route:'Ruta',
		dateTimeAndNumberOf:'Fecha, hora y numero de ',
		arrivalFlight:'Vuelo llegada',
		departureFlight:'Vuelo salida',
		pickupDatetime:'Fecha y hora de pickup',
		confirmData:'Confirmar datos',
		before:'antes',
		after:'despues',
		supplierNotes:'Notas al proveedor',
		flight:'vuelo',
		minutes:'minutos',
		serviceUpdatedSuccessfully:'Servicio actualizado con éxito',
		noShowEvidences:'Evidencias de No Show',
		noShowEvidenceMessage:'Para cambiar el estado del servicio a <strong>NO SHOW</strong>, por favor sube las pruebas correspondientes, que evidencien que el chófer y/o staff se encuentra en el tiempo y lugar programado.',
		doneEvidenceMessage:'Para cambiar el estado del servicio a <strong>REALIZADO</strong>, por favor sube las pruebas correspondientes, que evidencien que el chófer y/o staff se encuentra en el tiempo y lugar programado.',
		accepted:'Aceptado',
		shuttleCentralService:'Venta de Shuttle Central',
		selfService:'Servicio propio',
		rejectService:'Rechazar servicio',
		notes:'Notas',
		salesChannel:'Canal de venta',
		salesChannelReference:'Referencia canal de venta',
		salesChannelTitle:"Titulo canal de venta",
		noShow:'No Show',
		noProvided:'No atendido',
		cancel:'Cancelar',
		done:'Realizado',
		partialCancellation: 'Pre Cancelado',
		confirm:'Confirmar',
		copyRes:'Copiar reserva',
		createdBy:'Creado por',
		reservationDate:'Fecha de reservación',
		canceledBy:'Cancelado por',
		cancelationDate:'Fecha de cancelación',
		validate:'Validar',
		addService:'Agregar servicio',
		cancelRes:'Cancelar reserva',
		acceptService:'Aceptar servicio',
		servicesFrom: 'Servicios desde',
		servicesTo: 'hasta',
		clickFlightInfo:'Clic para ver la información del vuelo',
		flightNoValidate:'El vuelo no ha sido validado',
		newRes:'Nueva reserva',
		paxes:'Pasajeros',
		pickup:'Origen',
		dropoff:'Destino',
		transportInfo:'Datos del servicio',
		makeBooking:'Crear Reserva',
		Accepted: 'Servicios Confirmados',
		AcceptedOptions: {
			all: 'Todos',
			pending: 'Pendientes por confirmar',
			confirmed: 'Confirmados'
		},
		AcceptedOptionsMassive: {
			rejected: 'Rechazar',
			confirmed: 'Aceptar'
		},
		asignMsgPartial: "$TOTAL servicios no se pudieron actualizar ya que estaban previamente aceptados. Si requiere atencion adicional favor de contactar al personal de operaciones",
		asignMsg: 'Actualización exitosa',
		emptyStateSelect: 'No hay estado seleccionado',
		acceptReject: "Aceptar/Rechazar servicio",
		confirmAcceptService: "¿Estas seguro que desea ACEPTAR el servicio?",
		confirmRejectService : "¿Estas seguro que desea RECHAZAR el servicio?",
		dropService: "Soltar servicio",
		confirmDropService: "¿Estas seguro que desea SOLTAR el servicio? Esta acción no podrá revertirse.",
		serviceDroppedSuccessfully: "El servicio ha sido soltado exitosamente",
		dropServiceErrors: {
			time_window_expired: "No es posible soltar el servicio, faltan menos de 30 minutos para el pickup",
			time_window_not_started: "No es posible soltar el servicio, faltan más de 3 horas para el pickup"
		},
		selectServiceMassive: "Ningún servicio seleccionado",
		confirmSupplierConfirmationMassive:"¿Estas seguro que desea %{action} los servicios seleccionados?",
		assignDriverUnit: 'Asignación de conductor y vehículo',
		assign: 'Asignar',
		unassignedServices:'Servicios NO ASIGNADOS',
		assignedServices:'Servicios ASIGNADOS',
		reviews: 'Reseñas',
		withoutCommentsOnReview: 'El cliente no dejó comentarios',
		price: 'Tarifa',
		points: 'Puntos',
		assignDriverDefault: 'Asignar conductor por defecto',
		useFlightData:"Usar datos de vuelo",
		flightScheduleNoAvailable:'El horario no esta disponible',
		rateOverride: "Asignar tarifa manualmente",
		usePreviousMap: "Usar mapeo de importaciones previas",
		internalReference:"Referencia Interna",
		keyword:"Palabra clave",
		rateLocked:"Mantener tarifa",
		clientNote: "Notas de cliente",
		flightDate: "Fecha vuelo"
	},
	users : {
		newUser:'Nuevo usuario',
		newDriver:'Nuevo conductor',
		name:'Nombre',
		email:'Corre electrónico',
		access:'Acceso',
		status:'Estado',
		actions:'Acciones',
		editingUser:'Editando usuario',
		editingDriver:'Editando conductor',
		firstName:'Nombres',
		lastName:'Apellidos',
		phone:'Teléfono',
		userInfo:'Información de usuario',
		language:'Idioma',
		accessTypeOpts : {
			master : 'Maestro',
			admin : 'Administrador',
			operation : 'Operación',
			driver : 'Conductor',
		},
		license:'Licencia',
		profilePicture:'Foto de perfil',
		profile:'Perfil',
		msgRegistered: 'Usuario agregado con éxito',
		msgUpdate: 'Usuario actualizado con éxito',
		msgRemoved: 'Usuario eliminado con éxito',
		password: 'Contraseña',
		resetPassword: "Restablecer la contraseña",
		newPassword : 'Nueva contraseña',
		repeatPassword : 'Repetir contraseña',
		updatedPassword : 'Contraseña actualizada',
		passwordAreDifferent : 'Contraseña son diferentes'
	},
	profile : {
		firstName : 'Nombres',
		lastName : 'Apellidos',
		email : 'Correo electrónico',
		phone : 'Teléfono',
		language : 'Idioma',
		changePassword : 'Cambiar contraseña',
		newPassword : 'Nueva contraseña',
		repeatPassword : 'Repetir contraseña',
		updatePassword : 'Actualizar contraseña',
		updatedPassword : 'Contraseña actualizada',
		passwordAreDifferent : 'Las contraseñas son diferentes',
		updatedData : 'Datos actualizados',
		changeSass: 'Cambiar de plataforma',
	},
	transportUnits : {
		newUnit: 'Nueva unidad',
		name: 'Nombre',
		plateNumber: '# Placas',
		unitBrand: 'Marca',
		unitModel: 'Modelo',
		unitModelYear: 'Año',
		maxPassengers: 'Max pasajeros',
		editUnit: 'Editar unidad',
		info: 'Información',
		unitPhoto: 'Foto de unidad',
	},
	driver : {
		myServices:'Mis servicios',
		changeUnit:'Cambiar unidad',
		noPermission: "No se tiene permisos de ubicación, activa el permiso para esta pagina en tu dispositivo",
		howAndroid: "Ver como en ANDROID",
		acceptPermission: "Haz clic y acepta el permiso de ubicación",
		findLocation: "Haz clic para encontrar tu ubicación",
		withoutDriverData: "Sin datos de conductor"
	},
	AssignConfirmation: {
		oktitle: 'Asignar',
		title: 'Asignar confirmación',
		rowsMessage: 'Ha seleccionado $TOTAL registros para actualizar.'
	},
	confirm: {
		Si: true,
		No: false
	},
	transportServiceChangeStatus: {
		note: 'Registra una nota*',
		btnUpdate: 'Actualizar servicio',
		btnUpdateProcess: 'Procesando',
		btnCancel: 'Cancelar',
		title: 'Evidencias de estado',
	},
	transportServiceStatus: {
		pending:	'Pendiente',
		active:		'Activo',
		noShow:		'No show',
		noProvided:	'No atendido',
		canceled:	'Cancelado',
		done:		'Realizado',
		success:	'Servicio actualizado con éxito',
		partialCancellation: 'Pre Cancelado',
		activeDoneNoShow:"Activo+Realizado+No Show",
	},
	filesRelated: {
		emptyImg: 'No se ha cargado imagenes',
		fileDelete: 'Archivo eliminado',
		notSelectImg: 'No has seleccionado una imagen',
		uploadedFile: 'Archivo cargado',
	},
	statusOptions: {
		active: 'Activo',
		pending: 'Pendiente'
	},
	statusActive: {
		active: 'Activo',
		inactive: 'Inactivo'
	},
	accessTypes: {
		/*master: 'Maestro',*/
		admin: 'Administrador',
		operation: 'Operación',
		driver: 'Conductor',
	},
	langOptions: {
		es: 'Español',
		en: 'Ingles',
	},
	alerts:{
		trackingStatusChanged:"El servicio: {serviceNumber} ha cambiado de status a: {trackingStatus} "
	},
	dashboard:{
		startDate:"Fecha de inicio",
		endDate:"Fecha de finalización",
		compareBy:"Comparar por:",
		day:"Dia",
		week:"Semana",
		month:"Mes",
		year:"Año",
		volumenAssigned:"Servicios asignados",
		volumenAccepted:"Servicios aceptados",
		volumenRejected:"Servicios rechazados",
		ridesPerStatus:"Mi Operación",
		hideShowDataLabels:"Mostrar/Ocultar etiquetas",
		driverPerformance:"Desempeño por operador",
		myRides:"Mis servicios",
		reviewPerDate: "Reviews por fecha",
		evidences: "Evidencias solicitadas",
		evidencesTabs: {
			pending: "Pendientes",
			approved: "Aprobadas",
			rejected: "Rechazadas"
		},
		evidencesEmpty: {
			pending: "No hay evidencias pendientes",
			approved: "No hay evidencias aprobadas",
			rejected: "No hay evidencias rechazadas",
			global: "No hay evidencias para mostrar"
		},
		evidencesTable: {
			service: "Servicio",
			route: "Ruta",
			datetime: "Fecha/Hora",
			details: "Detalles",
			expires: "Expira",
			actions: "Acciones",
			sentAt: "Enviada",
			rejectionReason: "Motivo de Rechazo",
			noReasonSpecified: "Sin motivo especificado"
		},
		evidencesActions: {
			copyLink: "Copiar enlace",
			openForm: "Abrir formulario de evidencias",
			linkCopied: "Enlace copiado al portapapeles",
			linkCopyError: "Error al copiar el enlace"
		}
	},
	reports:{
		myRevenue:"Mis ingresos",
		datesValidation:"Campos de fecha son requeridos.",
		currency:"Moneda",
		rate:"$ Tarifa",
		referenceData:"La información que se muestra esta sujeta a cambios a medida que tus estados de traslados y tu operación son actualizados.",
		rangeLimit:"Limite excedido ({days} días maximo por consulta)",
		reviews: "Reseñas",
		editRates:"Editar Tarifas",
		saveRates:'Guardar Cambios',
		calculateRate:'Calcular Tarifa',
		rateNotFound:"No se encontró tarifa",
		promotions: "Promociones",
		withPromotion: "Con promoción"
	},
	rto:{
		drivers: "GPS Conductores",
		lastConnection:"Ultima actualización"
	},
	messages: {
		driverAssigned: "Este dato será distribuido (Ej. booking.com)",
		errorTrackingModule: "No puede cargar debido a que la información del ride es incorrecto, intente guardar los cambios antes de entrar al módulo.",
		chatNotAvailable: "Chat no disponible"
	},
	validations: {
		nameRequired: "Nombre es requerido",
		lastNameRequired: "Apellido es requerido",
		phoneRequired: "Phone es requerido",
		emailRequired: "Email es requerido"
	},
	tracking: {
		driverChat: 'Chat de conductor',
		localTime: 'Hora local'
	},
	history: {
		id: "Id",
		reservationId: "Reservación Id",
		pickupPlaceId: "Pickup",
		dropoffPlaceId: "Dropoff",
		supplierId: "Proveedor",
		salesChannelId: "Canal de venta",
		serviceTypeId: "Tipo servicio",
		creationUserId: "Creado por",
		supplierReference: "Referencia proveedor",
		salesChannelReference: "Referencia de canal de venta",
		supplierNotes: "Notas proveedor",
		flightNumber: "Número de vuelo",
		flightDatetime: "Fecha|Hora vuelo",
		pickupDatetime: "Fecha|Hora pickup",
		bookingPriceSubtotal: "Subtotal precio booking",
		netPriceSubtotal: "Subtotal precio neto",
		supplierPriceSubtotal: "Subtotal precio proveedor",
		creationDatetime: "Fecha|Hora de creación",
		cancelDatetime: "Fecha|Hora de cancelación",
		cancelUserId: "Cancelado por",
		contactStatus: "Estatus de contacto",
		consecutiveId: "Id Consecutivo",
		pickupDatetimeConfirmed: "Fecha|Hora pickup confirmado",
		bookingPriceTotal: "Precio total booking",
		netPriceTotal: "Precio total neto",
		supplierPriceTotal: "precio total proveedor",
		pointOfSaleId: "Punto de venta",
		clientPickupPlaceId: "Pickup cliente",
		clientDropoffPlaceId: "Dropoff cliente",
		salesChannelReservationReference: "Referencia de reservacíon canal de venta",
		source: "Origen",
		flightValidationStatus: "Estatus de validación de vuelo",
		flightValidationData: "Datos validación de vuelo",
		userDriverId: "Conductor",
		transportUnitId: "Vehículo",
		supplierSalesChannel: "Canal de venta proveedor",
		trackingStatus: "Estatus de rastreo",
		supplierConfirmation: "Confirmacíon de proveedor",
		supplierCurrency: "Moneda de proveedor",
		pickupDatetimeUtc: "Fecha|Hora UTC pickup",
		status: "Estatus",
		checkinStatus: "Estatus Check in",
		travelTime: "Tiempo de viaje",
		travelLength: "Distancia de viaje",
		clientNote: "Nota de cliente",
		bookingCurrency: "Moneda de booking",
		netCurrency: "Moneda neta",
		ratePlanId: "Plan tarifario",
		paymentStatus: "Estatus de pago",
		ticket: "Ticket",
		carrierCode: "Carrier code",
		flightNumberValidation: "Número de vuelo validado",
		actualFlightDatetime: "Fecha|Hora de vuelo actual",
		reasonStateId: "Razón de estado",
		ratePlanData: "Datos de plan tarifario",
		bookingPriceOverride: "Precio de booking bloqueado",
		netPriceOverride: "Precio neto Bloqueado",
		supplierPriceOverride: "Precio de proveedor bloqueado",
		supplierServiceTypeId: "Tipo de servicio proveedor",
		supplierPromoData: "Datos de promocion proveedor",
		revisedUserId: "Revisado por",
		revisedAt: "Fecha revisado",
		supplierAssignedAt: "Fecha proveedor asignado",
		serviceTypeCategoryId: "Categoria de tipo de servicio",
		pickupZoneId: "Zona pickup",
		dropoffZoneId: "Zona dropoff",
		salesChannelPromoData: "Datos de promoción canal de venta",
		promoCode: "Código de promoción",
		reviewId: "Review",
		accessType: "Tipo de acceso",
		firstName: "Nombre",
		lastName: "Apellido",
		email: "Email",
		phone: "Teléfono",
		updated_at: "Actualizado",
		created_at: "Creado",
		paymentTotal: "Total de pago",
		operatedBy: "Operado por",
		clientId: "Cliente",
		adults: "Adultos",
		children: "Menores",
		infants: "Infantes",
		reservationDatetime: "Fecha|Hora de reservación",
		promoApplied: 'Promo Aplicada',
		promoData: 'Promo Informacion',
	},
	saleChannel:{
		new:"Nuevo Canal de venta",
		edit:"Editar Canal de venta",
		name:"Nombre",
		code:"Codigo",
		saleChannel:"Canales de ventas",
		confirmDelete: "Está seguro que desea eliminar el canal de venta: {saleChannel}"

	},
	zonedArea:{
		operationZones: "Areas de Operación",
		new: "Nueva Area de Operación",
		zones:"Zonas",
		restore:"Reestablecer",
		priority:"Prioridad",
		goToList:"Ir a la lista",
		confirmDelete:"Esta Área de Operación ya ha sido guardada en el sistema. Si la eliminas, todos los planes tarifarios conectados se verán afectados",
		confirmDeleteZone:"Esta zona ya ha sido guardada en el sistema, si eliminas una zona se eliminaran todos los costos cargados para dicha zona",
		detailsAndEdit:"Detalles y Configuración, Administración de zonas"
	},
	serviceType:{
		module:"Tipos de servicio",
		new:"Nuevo Tipo de servicio",
		name:"Nombre",
		code:"Codigo",
		maxPax:"Max Pax",
		maxSuiteCases:"Max maletas",
		category:"Categoria Vehiculo",
		description:"Descripción",
		serviceType:"Tipo de servicio",
		edit:"Editar tipo de servicio",
		confirmDelete:"Está seguro que desea eliminar el tipo de servicio: {serviceType}"
	},
	ratePlan:{
		data:"Plan tarifario",
		currency:"Moneda",
		operationArea:"Area de operación",
		startDate:"Fecha reserva inicio",
		endDate:"Fecha reserva fin",
		showZonedAreaSelected:"Ver área de operación",
		confirmDelete:"Si eliminas este plan tarifario ( {ratePlanName} ) se eliminaran todos los precios cargados en este plan tarifario",
		summary:"Resumen",
		selectOrigin:"Seleccione origen",
		selectDestination:"Seleccione destino",
		msjPrice0:"**Prices at 0 means that the service is not allowed",
		applyOpposite:"Apply costs to transportation on the opposite trip",
		selectFromAndTo: "Seleccione <b>Origen</b> y <b>Destino</b> para continuar..."
	},
	assignation:{
		assigned:"Asignados",
		selectDrivertoContinue: "Seleccione un conductor",
		operation: "Logistica",
		noRides:"Sin servicios asignados",
		summary:"Resumen asignación",
		assignChange:"Asignar/Cambiar conductor"
	},
	timeline: {
		historyChanges: "Lista de cambios",
		lastChangesSubtitle: "Cambios realizados desde la última confirmación.",
		lastChange: "Ultimo",
		changeType: "Tipo de cambio",
		changes: "Cambios",
		dateChange: "Fecha de cambio",
		clientChange: "Cambio realizado por cliente",
		systemChange: "Cambio realizado por el sistema",
		refresh: "Recargar"
	},
	notifications: {
		title: "Notificaciones",
		markAllRead: "Marcar todo como leído",
		empty: "No hay notificaciones",
		viewAll: "Ver todas",
		justNow: "Justo ahora",
		minutesAgo: "Hace {count} min",
		hoursAgo: "Hace {count} h",
		daysAgo: "Hace {count} d",
		expiresIn: "caduca en",
		expiringSoon: "Expira pronto",
		expired: "Expiró",
		minutes: "minuto | minutos",
		hours: "hora(s)"
	},
	flightInfo: {
		noMonitoring: "Sin monitoreo",
		cancelled: "Cancelado",
		onTime: "A tiempo",
		title: "Info de Vuelo",
		loading: "Cargando...",
		noFlightInfo: "Sin información de vuelo disponible",
		checkLanding: "Comprobar aterrizaje",
		early: "Adelantado",
		delayed: "Demorado",
		late: "Atrasado",
		progress: "Progreso",
		originalFlight: "Vuelo original",
		scheduledDeparture: "Salida prog.",
		actualDeparture: "Salida real",
		departureDelay: "Demora salida",
		estimatedLanding: "Aterrizaje est.",
		actualLanding: "Aterrizaje real",
		estimatedGateArrival: "Llegada puerta est.",
		actualGateArrival: "Llegada puerta real",
		arrivalGate: "Puerta lleg",
		terminal: "Terminal",
		baggage: "Equipaje",
		hoverToLoad: "Pase el cursor para cargar info"
	},
	evidences: {
		loading: "Cargando...",
		linkExpired: "Enlace expirado",
		linkExpiredHint: "Este servicio permanece con Status 'No Atendido' y no será incluido a pago",
		error: "Error",
		title: "Evidencias",
		uploadTitle: "Subir Evidencias",
		alreadyUploaded: "Las evidencias de este servicio ya fueron cargadas correctamente.",
		client: "Cliente",
		pickup: "Pickup",
		dropoff: "Dropoff",
		dateTime: "Fecha/Hora",
		type: "Tipo",
		trip: "Viaje",
		passengers: "Pasajeros",
		flight: "Vuelo",
		channel: "Canal",
		important: "Importante:",
		warningMessage: "Debes subir las 4 evidencias antes de que expire este enlace para validar el servicio. De lo contrario, el servicio quedará registrado como",
		notProvided: "no atendido",
		deadline: "Fecha límite:",
		serviceEvidences: "Evidencias del servicio",
		evidencesUploaded: "Evidencias cargadas para este servicio",
		uploadHint: "Sube 4 fotos como evidencia del servicio realizado",
		sending: "Enviando...",
		submitEvidences: "Enviar Evidencias",
		imagesSelected: "{count} de 4 imágenes seleccionadas",
		tripLabels: {
			H2A: "Hotel → Aeropuerto",
			A2H: "Aeropuerto → Hotel"
		},
		statusLabels: {
			noProvided: "No Atendido",
			provided: "Realizado",
			pending: "Pendiente"
		},
		imageNames: {
			gps1: "GPS 1: Captura tu ubicación justo al llegar o unos minutos antes del pickup.",
			gps2: "GPS 2: Captura tu ubicación al retirarte del punto de pickup (con o sin pasajero).",
			photo1: "Foto 1: Lugar del encuentro: Toma una foto del punto de espera (debe ser a la misma hora que el GPS 1)",
			photo2: "Foto 2: Destino o salida: Foto al dejar al cliente o foto del lugar al retirarte si el cliente no llegó."
		},
		uploadError: "Error al subir la imagen. Intenta de nuevo.",
		submitError: "Error al enviar las evidencias. Intenta de nuevo.",
		submitSuccess: "Evidencias enviadas correctamente"
	}
}
